
document.addEventListener('DOMContentLoaded', function() {
  var btn = document.getElementById('scroll-to-top');
  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 200) {
      btn.classList.add('show');
    } else {
      btn.classList.remove('show');
    }
  });
  btn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});
